<template>
  <div class="drivers container-fluid r-aside">
    <loading :active.sync="isLoading"
             :can-cancel="true">
    </loading>

    <div class="row page-titles">
        <div class="col-md-5 align-self-center">
            <h3 class="text-themecolor">{{ title }}</h3>
        </div>
        <div class="col-md-7 align-self-center">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><a href="javascript:void(0)">Home</a></li>
                <li class="breadcrumb-item active">{{ title }}</li>
            </ol>
        </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <form class="form-material">
              <div class="ride-filters">
                <div class="col-md-12 col-lg-12 m-0 p-0 ride-filter">
                  <div class="sub-header row">
                    <!-- <div class="col-md-4 col-lg-4 p-0">
                      <div class="m-3">
                        <label class="search-label">Rider Email</label>
                        <input v-model="rider_email" class="form-control form-control-sm" placeholder="Rider Email" style="width:100%" type="text"
                               id="assign_ride_search_rider_email">
                      </div>
                    </div> -->

                    <div class="col-md-2 col-lg-2 p-0">
                      <div class="m-3">
                        <label class="search-label">Trip ID</label>
                        <input v-model="id_group_ride" class="form-control form-control-sm" placeholder="Trip ID" style="width:100%" type="text"
                               id="assign_ride_search_group_idd">
                      </div>
                    </div>
                    <div class="col-md-2 col-lg-2 p-0">
                      <div class="m-3 form-ddown">
                        <label class="search-label">Beginning Reservation Date</label>
                        <datetime type="datetime" v-model="min_reservation_date" input-class="form-control form-control-sm" placeholder="Min Reservation Date" label="Min Reservation Date" :noClearButton="false">
                        </datetime>
                        <font-awesome-icon v-if="min_reservation_date" @click="clearDate('min_reservation_date')" icon="times" style="color: red; cursor: pointer"/>
                      </div>
                    </div>
                    <div class="col-md-2 col-lg-2 p-0">
                      <div class="m-3 form-ddown">
                        <label class="search-label">Maximum Reservation Date</label>
                        <datetime type="datetime"  v-model="max_reservation_date" label="Max Reservation Date" input-class="form-control form-control-sm" placeholder="Max Reservation Date" >
                        </datetime>
                        <font-awesome-icon v-if="max_reservation_date" @click="clearDate('max_reservation_date')" icon="times" style="color: red; cursor: pointer"/>
                      </div>
                    </div>

                    <div class="col-md-2 col-lg-2 p-0">
                      <div class="m-3 form-ddown">
                        <label class="search-label">Beginning Date</label>
                        <datetime type="datetime" v-model="min_date" input-class="form-control form-control-sm" placeholder="Min Departure Date" label="Min Departure Date" :noClearButton="false">
                        </datetime>
                        <font-awesome-icon v-if="min_date" @click="clearDate('min_date')" icon="times" style="color: red; cursor: pointer"/>
                      </div>
                    </div>
                    <div class="col-md-4 col-lg-4 p-0">
                      <div class="m-3 form-ddown">
                        <label class="search-label">Maximum Date</label>
                        <datetime type="datetime"  v-model="max_date" label="Max Departure Date" input-class="form-control form-control-sm" placeholder="Max Departure Date" >
                        </datetime>
                        <font-awesome-icon v-if="max_date" @click="clearDate('max_date')" icon="times" style="color: red; cursor: pointer"/>
                      </div>
                    </div>


                    <div class="col-md-2 col-lg-2 p-0">
                      <div class="m-3">
                        <label class="search-label">Driver First Name</label>
                        <input v-model="driver_name_first" class="form-control form-control-sm" placeholder="Driver First Name" style="width:100%" type="text"
                               id="current_ride_search_driver_firstname">
                      </div>
                    </div>
                    <div class="col-md-2 col-lg-2 p-0">
                      <div class="m-3">
                        <label class="search-label">Driver Last Name</label>
                        <input v-model="driver_name_last" class="form-control form-control-sm" placeholder="Driver Last Name" style="width:100%" type="text"
                               id="current_ride_search_driver_lastname">
                      </div>
                    </div>

                    <div class="col-md-2 col-lg-2 p-0">
                      <div class="m-3">
                        <label class="search-label">Rider First Name</label>
                        <input v-model="rider_name_first" class="form-control form-control-sm" placeholder="Rider First Name" style="width:100%" type="text"
                               id="assign_ride_search_rider_firstname">
                      </div>
                    </div>
                    <div class="col-md-2 col-lg-2 p-0">
                      <div class="m-3">
                        <label class="search-label">Rider Last Name</label>
                        <input v-model="rider_name_last" class="form-control form-control-sm" placeholder="Rider Last Name" style="width:100%" type="text"
                               id="assign_ride_search_rider_lastname">
                      </div>
                    </div>

                    <div class="col-md-2 col-lg-2 p-0">
                      <div class="m-3">
                        <label class="search-label">From</label>
                        <input v-model="default_pickup_address" class="form-control form-control-sm" placeholder="From" style="width:100%" type="text"
                               id="assign_ride_search_pickup_address">
                      </div>
                    </div>
                    <div class="col-md-2 col-lg-2 p-0">
                      <div class="m-3">
                        <label class="search-label">To</label>
                        <input v-model="default_dropoff_address" class="form-control form-control-sm" placeholder="To" style="width:100%" type="text"
                               id="assign_ride_search_dropoff_address">
                      </div>
                    </div>

                    <div class="col-md-2 col-lg-2 p-0">
                      <div class="m-3">
                        <label class="search-label">Select a Status</label>
                        <select type="text" placeholder="Status"
                                class="form-control ddown" id="status-filter" v-model="selected_status">
                          <option v-bind:value=null>
                            All
                          </option>
                          <option v-for="(index, item) in data.filters.status" v-bind:value="index" :key="index">
                            {{item.replace(item.charAt(0), item.charAt(0).toUpperCase()).replace("_", " ").replace("_", " ").replace("linear", "General").replace("logarithmic", "Accelerated")}}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="col-md-2 col-lg-2 p-0">
                      <div class="m-3">
                        <label class="search-label">Market</label>
                        <select type="text" placeholder="Market" class="form-control ddown" id="market-filter" v-model="selected_market">
                          <option v-bind:value="'All'" >
                            All
                          </option>
                          <option v-for="market in markets" v-bind:value="market" v-bind:key="market.id_market">
                            {{ market.name }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div class="col-md-2 col-lg-2 p-0">
                      <div class="m-3">
                        <label class="search-label">Ride Type</label>
                        <select type="text" placeholder="Ride Type"
                                class="form-control ddown" id="ride-type-filter" v-model="selected_ride_type">
                          <option v-bind:value="'All'">
                            All
                          </option>
                          <option v-bind:value="0">
                            Regular
                          </option>
                          <option v-bind:value="1">
                            Deadhead
                          </option>
                        </select>
                      </div>
                    </div>

                    <div class="col-md-2 col-lg-2 p-0">
                      <div class="m-3">
                        <label class="search-label">Booking Mode</label>
                        <select type="text" placeholder="Booking Mode"
                                class="form-control ddown" id="booking-mode-filter" v-model="selected_booking_mode">
                          <option v-bind:value="'All'">
                            All
                          </option>
                          <option v-bind:value="'S'">
                            Standing Order
                          </option>
                          <option v-bind:value="'D'">
                            Demand
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="col-12 m-3 p-0 submit-button">
                      <a @click="assignButtonSearch()" style="color: white" class="btn btn-info waves-effect waves-light m-t-10" > Search </a>
                    </div>
                  </div>

                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="">
              <form v-on:submit.prevent>
                <table class="table table-sm table-hover" data-sort-name="Date">
                  <thead>
                    <tr>
                      <th>
                        Page Size
                      </th>
                      <th>
                        <select v-model="perPage" class="form-control table-select" @change="checkPageSize($event)">
                          <option v-for="size in page_sizes">
                            {{size}}
                          </option>
                        </select>
                      </th>
                    </tr>
                    <br>
                    <tr>
                      <th class="result-label">
                        <select class="form-control table-select" @change="checkSelection($event)" onfocus="this.selectedIndex = 0">
                          <option selected="selected">
                            Select
                          </option>
                          <option>
                            All
                          </option>
                          <option>
                            None
                          </option>
                        </select>
                      </th>
                      <th class="result-label" v-for="column in data.resultColumns" v-on:click="sortResults($event)">
                        <div>
                          {{column}}
                          <div class="arrow-down" v-bind:id="column" style="visibility: hidden; margin-left: 5px;"></div>
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody class="col-12">
                    <tr class="ride-item text-xs-center" v-for="ride in data.sortedRides" >
                      <!-- Checkbox -->
                      <td class="result-item text-center" width="80px">
                        <input type='checkbox' v-bind:value='ride' v-model='data.pool' v-bind:id="ride.id_ride">
                        <label class="search-label" v-bind:for="ride.id_ride" style="margin-bottom: 0; padding: 0px 0px 0px 26px; height: 15px;"></label>
                      </td>
                      <!-- Ride ID -->
                      <td class="result-item">
                        <router-link :to="'/rides/' + ride.id_ride + '/'">
                          <!--<router-link :to="{name: 'Rides', params: {id_ride: ride.id_ride}}">-->
                          {{ ride.id_ride }}
                        </router-link>
                      </td>
                      <!-- Alternate ID -->
                      <td class="result-item">
                        <router-link :to="'/rides/' + ride.id_ride + '/'">
                          <!--<router-link :to="{name: 'Rides', params: {id_ride: ride.id_ride}}">-->
                          <div v-if="ride.id_alternate != null" style="margin-top: inherit !important;">{{ ride.id_alternate }}</div>
                          <div v-if="ride.id_alternate == null" style="margin-top: inherit !important;">None</div>
                        </router-link>
                      </td>
                      <td class="result-item">
                        <router-link :to="'/search-rides/?id_group_ride=' + ride.id_group_ride" v-if="ride.id_group_ride" style="padding: 0.3rem;" target="_blank">
                          {{ ride.id_group_ride }}
                        </router-link>

                        <component v-if="!ride.id_group_ride">{{ 'N/A' }}</component>
                      </td>
                      <!-- Market -->
                      <td class="result-item">
                        <div>
                          <div v-if="ride.id_market != null">{{ ride.id_market.name }}</div>
                        </div>
                      </td>
                      <!-- Ride Type -->
                      <td class="result-item">
                        <div>
                          <div>{{ ride.deadhead && ride.deadhead == 1 ? 'Deadhead' : 'Regular' }}</div>
                        </div>
                      </td>
                       <!-- Vehicle Type -->
                      <td class="result-item">
                        <div>
                          <div>{{ ride.tag_values | rideTags('vehicle_type') }}</div>
                        </div>
                      </td>
                      <!-- Booking Mode -->
                      <td class="result-item">
                        <div>
                          <div>{{ ride.booking_mode }}</div>
                        </div>
                      </td>
                      <!-- Partner -->
<!--                      <td class="result-item">-->
<!--                        <router-link v-if="ride.id_rider" :to="'/users/' + ride.id_rider.id_user + '/'">-->
<!--                          <div v-if="ride.id_rider.id_business_provider != null">{{ ride.id_rider.id_business_provider.name }}</div>-->
<!--                        </router-link>-->
<!--                      </td>-->
                      <!-- Rider ID -->
                      <td class="result-ite">
                        <router-link v-if="ride.id_rider" :to="'/users/' + ride.id_rider.id_user + '/'">
                          <div>
                            {{ (ride.contact_first_name ? ride.contact_first_name : ride.id_rider.name_first) + " " + (ride.contact_last_name ? ride.contact_last_name : ride.id_rider.name_last) }}
                          </div>
                        </router-link>
                      </td>
                      <!-- Booked At -->
                      <td class="result-item">
                        <span class="">
                          <!--{{ moment(ride.date_reservation).format("YYYY-MM-DD HH:mm")  + " (" + moment.tz(moment.tz.guess()).format('z') + ")" }}-->
                          {{ !ride.date_reservation ? 'N/A' : ride.local_timezone ? moment.utc(ride.date_reservation).tz(ride.local_timezone).format('MMMM Do YYYY, h:mm:ss a (z)') : moment.utc(ride.date_reservation).format('MMMM Do YYYY, h:mm:ss a (z)')}}
                        </span>
                      </td>
                      <!-- Expires At -->
                      <td class="result-item">
                        <span v-if="ride.date_expiration != null" class="">
                          <!--{{ moment(ride.date_expiration).format("YYYY-MM-DD HH:mm")  + " (" + moment.tz(moment.tz.guess()).format('z') + ")" }}-->
                          {{ !ride.date_expiration ? 'N/A' : ride.local_timezone ? moment.utc(ride.date_expiration).tz(ride.local_timezone).format('MMMM Do YYYY, h:mm:ss a (z)') : moment.utc(ride.date_expiration).format('MMMM Do YYYY, h:mm:ss a (z)')}}
                        </span>
                        <span v-else class="">N/A</span>
                      </td>
                      <!-- Pickup Date -->
                      <td class="result-item">
                        <span class="">
                          <!--{{ moment(ride.date_pickup).format("YYYY-MM-DD HH:mm")  + " (" + moment.tz(moment.tz.guess()).format('z') + ")" }}-->
                          {{ !ride.date_pickup ? 'N/A' : ride.local_timezone ? moment.utc(ride.date_pickup).tz(ride.local_timezone).format('MMMM Do YYYY, h:mm:ss a (z)') : moment.utc(ride.date_pickup).format('MMMM Do YYYY, h:mm:ss a (z)')}}
                        </span>
                      </td>
                      <!-- From -->
                      <td class="result-item">
                        <span class="">{{ ride.default_pickup_address }}</span>
                      </td>
                      <!-- To -->
                      <td class="result-item">
                        <span class="">{{ ride.default_dropoff_address }}</span>
                      </td>
                      <!-- Driver Revenue -->
                      <td class="result-item">
                        <span class="">${{ ride.price_driver_revenue ? ride.price_driver_revenue.toFixed(2) : 'N/A'}}</span>
                      </td>
                      <!-- Status -->
                      <td class="result-item">
                        <span class="">{{ ride.id_type_ride_status.name }}</span>
                      </td>
                    </tr>
                  </tbody>
                  <div>
                    <h4 v-if="data.finishedPool.length > 0">Recently Assigned Rides</h4>
                  </div>
                  <tbody class="col-12">
                    <tr class="ride-item text-xs-center" v-for="ride in data.finishedPool" >
                      <!-- Checkbox -->
                      <td class="result-item text-center" width="80px">
                        <input type='checkbox' v-bind:value='ride' v-model='data.pool' v-bind:id="ride.id_ride">
                        <label class="search-label" v-bind:for="ride.id_ride" style="margin-bottom: 0; padding: 0px 0px 0px 26px; height: 15px;"></label>
                      </td>
                      <!-- Ride ID -->
                      <td class="result-item">
                        <router-link :to="'/rides/' + ride.id_ride + '/'">
                          <!--<router-link :to="{name: 'Rides', params: {id_ride: ride.id_ride}}">-->
                          {{ ride.id_ride }}
                        </router-link>
                      </td>
                      <!-- Alternate ID -->
                      <td class="result-item">
                        <router-link :to="'/rides/' + ride.id_ride + '/'">
                          <!--<router-link :to="{name: 'Rides', params: {id_ride: ride.id_ride}}">-->
                          <div v-if="ride.id_alternate != null" style="margin-top: inherit !important;">{{ ride.id_alternate }}</div>
                          <div v-if="ride.id_alternate == null" style="margin-top: inherit !important;">None</div>
                        </router-link>
                      </td>
                      <td class="result-item">
                          <div style="margin-top: inherit !important;">{{ ride.id_group_ride ? ride.id_group_ride : 'N/A' }}</div>
                      </td>
                      <!-- Market -->
                      <td class="result-item">
                        <div>
                          <div v-if="ride.id_market != null">{{ ride.id_market.name }}</div>
                        </div>
                      </td>
                      <!-- Ride Type -->
                      <td class="result-item">
                        <div>
                          <div>{{ ride.deadhead && ride.deadhead == 1 ? 'Deadhead' : 'Regular' }}</div>
                        </div>
                      </td>
                      <!-- Partner -->
                      <td class="result-item">
                        <router-link v-if="ride.id_rider" :to="'/users/' + ride.id_rider.id_user + '/'">
                          <div v-if="ride.id_rider.id_business_provider != null">{{ ride.id_rider.id_business_provider.name }}</div>
                        </router-link>
                      </td>
                      <!-- Rider ID -->
                      <td class="result-ite">
                        <router-link v-if="ride.id_rider" :to="'/users/' + ride.id_rider.id_user + '/'">
                          <div v-if="ride.contact_first_name != null && ride.contact_last_name != null">({{ ride.contact_first_name + " " + ride.contact_last_name }})</div>
                          <div v-else>{{ ride.id_rider.name_first + " " + ride.id_rider.name_last }}</div>
                        </router-link>
                      </td>
                      <!-- Booked At -->
                      <td class="result-item">
                        <span class="">
                          {{ !ride.date_reservation ? 'N/A' : ride.local_timezone ? moment.utc(ride.date_reservation).tz(ride.local_timezone).format('MMMM Do YYYY, h:mm:ss a (z)') : moment.utc(ride.date_reservation).format('MMMM Do YYYY, h:mm:ss a (z)')}}
                        </span>
                      </td>
                      <!-- Expires At -->
                      <td class="result-item">
                        <span v-if="ride.date_expiration != null" class="">
                          {{ !ride.date_expiration ? 'N/A' : ride.local_timezone ? moment.utc(ride.date_expiration).tz(ride.local_timezone).format('MMMM Do YYYY, h:mm:ss a (z)') : moment.utc(ride.date_expiration).format('MMMM Do YYYY, h:mm:ss a (z)')}}
                        </span>
                        <span v-else class="">N/A</span>
                      </td>
                      <!-- Pickup Date -->
                      <td class="result-item">
                        <span class="">
                          {{ !ride.date_pickup ? 'N/A' : ride.local_timezone ? moment.utc(ride.date_pickup).tz(ride.local_timezone).format('MMMM Do YYYY, h:mm:ss a (z)') : moment.utc(ride.date_pickup).format('MMMM Do YYYY, h:mm:ss a (z)')}}
                        </span>
                      </td>
                      <!-- From -->
                      <td class="result-item">
                        <span class="">{{ ride.default_pickup_address }}</span>
                      </td>
                      <!-- To -->
                      <td class="result-item">
                        <span class="">{{ ride.default_dropoff_address }}</span>
                      </td>
                      <!-- Fare -->
                      <td class="result-item">
                        <span class="">{{ ride.price_total }}</span>
                      </td>
                      <!-- Status -->
                      <td class="result-item">
                        <span class="">Accepted</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </form>

              <div style="background-color: rgba(0, 0, 0, 0.05); float: left; width: 100%;">
                <div style="margin: 1rem 1rem; float: left;">
                  <span v-if="totalRows > 0">Showing {{ perPage * (currentPage-1) + 1 }} to {{ perPage * currentPage > totalRows ? totalRows : perPage * currentPage }} of {{ totalRows }} entries</span>
                  <span v-else>Showing 0 entries</span>                </div>
                <div style="margin: 0 1rem; float: right;">
                  <b-pagination style="margin: .5rem 0;" align="center" :total-rows=totalRows v-model="currentPage" :per-page=perPage :limit=limit @change="changePage">
                  </b-pagination>
                </div>
              </div>
            </div>
            <div class="row assign-ride-actions" style="margin: 25px 0;">
              <div class="submit-button">
                <button v-on:click="data.showSendBackModal = true" class="btn btn-info waves-effect waves-light m-t-10" >Cancel</button>
              </div>
              <!--<div class="submit-button">-->
                <!--<button v-on:click="data.showStatusUpdateModal = true" class="btn btn-info waves-effect waves-light m-t-10" >Payment Pending</button>-->
              <!--</div>-->

              <div class="submit-button">
                <button id="assign" v-on:click="data.showDriverSelectModal = true" class="btn btn-info waves-effect waves-light m-t-10" >Assign to Driver</button>
              </div>
              <div class="submit-button">
                <button id="general" v-on:click="distribute($event)" class="btn btn-info waves-effect waves-light m-t-10">General Distribution</button>
              </div>
              <!--<div class="submit-button">-->
                <!--<button id="accelerated" v-on:click="distribute($event)" class="btn btn-info waves-effect waves-light m-t-10">Accelerated Distribution</button>-->
              <!--</div>-->
              <div class="submit-button">
                <button id="blast" v-on:click="distribute($event)" class="btn btn-info waves-effect waves-light m-t-10">Blast</button>
              </div>
              <div class="submit-button">
                <button id="assign" v-on:click="data.showAutoAssignModal = true" class="btn btn-info waves-effect waves-light m-t-10" >Auto assign rides</button>
              </div>


            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Error popup alert -->
    <div id="showErrorModal">
      <!-- use the modal component, pass in the prop -->
      <modal v-if="data.showErrorModal" @close="data.showErrorModal = false">
        <h3 slot="header">Error</h3>
        <h5 slot="body">No rides selected</h5>
      </modal>
    </div>
    <!-- Auto assign rides popup alert -->
    <div>
      <div>
        <!-- use the modal component, pass in the prop -->
        <modal v-if="data.showAutoAssignModal" @close="data.showAutoAssignModal = false">
          <h3 slot="header">
            The following rides have been selected to be auto assigned. <br>
            Please click 'Auto Assign' to proceed.
          </h3>
          <div slot="body">
            <form v-on:submit.prevent class="form-material">
              <div>
                <span class="font-weight-bold">Selected rides:</span>
                <br>
                <span v-for="ride in data.pool">{{ride.id_ride}}, </span>
              </div>
              <br>
              <br>

            </form>
          </div>
          <div slot="footer" >
            <button class="modal-default-button btn btn-info waves-effect waves-light m-t-10" @click="auto_assign($event)">
              Auto Assign
            </button>
            <button class="modal-default-button btn btn-default m-t-10" @click="data.showAutoAssignModal = false">
              Cancel
            </button>
          </div>
        </modal>
      </div>
    </div>
    <!-- Driver selection popup alert -->
    <div>
      <div>
        <!-- use the modal component, pass in the prop -->
        <modal v-if="data.showDriverSelectModal" @close="data.showDriverSelectModal = false">
          <h3 slot="header">
            Please select a driver
          </h3>
          <div slot="body">
            <form v-on:submit.prevent class="form-material">
              <div>
                <span class="font-weight-bold">Selected rides:</span>
                <br>
                <span v-for="ride in data.pool">{{ride.id_ride}}<br></span>
              </div>
              <br>
              <br>
              <select id="driver-selection" type="text" placeholder="Driver"
                      class="form-control ddown">
                <option>
                  {{data.driverSelectMessage}}
                </option>
                <option v-for="(item) in data.drivers"  v-bind:key="item.id_driver.id" v-if="filterDriverByMarkets(item)">
                  {{ (item.id_user ? item.id_user + " - " : '') + (item.name_first ? item.name_first : '') + " " + (item.name_last ? item.name_last : '') + ' - ' + (item.id_driver.id_type_driver_account ? item.id_driver.id_type_driver_account.code : 'N/A') + ' - ' + (item.id_driver.id_market ? item.id_driver.id_market.name : 'N/A') + ' - '}}{{item.tags | driverTags}}
                </option>
              </select>
            </form>
          </div>
          <div slot="footer" >
            <button class="modal-default-button btn btn-info waves-effect waves-light m-t-10" @click="assign($event)">
              Submit
            </button>
            <button class="modal-default-button btn btn-default m-t-10" @click="data.showDriverSelectModal = false">
              Cancel
            </button>
          </div>
        </modal>
      </div>
    </div>

    <!-- Send-back confirmation popup alert -->
    <div id="sendBackConfirmation">
      <div v-if="this.data.pool.length > 0">
        <modal v-if="data.showSendBackModal" @close="data.showSendBackModal = false">
          <h3 slot="header">Confirm Ride Send-Back</h3>
          <h5 slot="body">Should this cancellation status be sent to SouthEasTrans?</h5>
          <div slot="footer" >
            <button id="cancelTrue" style="width: 80px; margin-left: 10px;" class="modal-default-button btn btn-info waves-effect waves-light m-t-10" @click="data.showSendBackModal = false; distribute($event);">
              Yes
            </button>
            <button id="cancelFalse" style="width: 80px; margin-left: 10px;" class="modal-default-button btn btn-info waves-effect waves-light m-t-10" @click="data.showSendBackModal = false; distribute($event);">
              No
            </button>
            <button style="width: 80px; margin-left: 10px;" class="modal-default-button btn btn-info waves-effect waves-light m-t-10" @click="data.showSendBackModal = false;">
              Back
            </button>
          </div>
        </modal>
      </div>
      <div v-else>
        <modal v-if="data.showSendBackModal" @close="data.showSendBackModal = false">
          <h3 slot="header">Cancel Ride</h3>
          <h5 slot="body">Please select at least one ride</h5>
          <div slot="footer" >
            <button style="width: 60px;" class="modal-default-button btn btn-info waves-effect waves-light m-t-10" @click="data.showSendBackModal = false">
              Ok
            </button>
          </div>
        </modal>
      </div>
    </div>

    <!-- Payment pending confirmation popup alert -->
    <div>
      <div v-if="this.data.pool.length > 0">
        <modal v-if="data.showStatusUpdateModal" @close="data.showStatusUpdateModal = false">
          <h3 slot="header">Update to Payment Pending</h3>
          <h5 slot="body">Please confirm updating the status for these rides to Payment Pending</h5>
          <div slot="footer">
            <button style="width: 80px; margin-left: 10px;" class="modal-default-button btn btn-info waves-effect waves-light m-t-10" @click="data.showStatusUpdateModal = false;">
              Back
            </button>
            <button id="paymentPendingTrue" style="width: 80px; margin-left: 10px;" class="modal-default-button btn btn-info waves-effect waves-light m-t-10" @click="data.showStatusUpdateModal = false; distribute($event)">
              Confirm
            </button>
          </div>
        </modal>
      </div>
      <div v-else>
        <modal v-if="data.showStatusUpdateModal" @close="data.showStatusUpdateModal = false">
          <h3 slot="header">Update to Payment Pending</h3>
          <h5 slot="body">Please select at least one ride</h5>
          <div slot="footer" >
            <button style="width: 60px;" class="modal-default-button btn btn-info waves-effect waves-light m-t-10" @click="data.showStatusUpdateModal = false">
              Ok
            </button>
          </div>
        </modal>
      </div>
    </div>

  </div>
</template>

<script>
  import Vue from 'vue'

  // Import component
  import Loading from 'vue-loading-overlay'
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css'

  // register modal component
  Vue.component('modal', {
    template: '#modal-template'
  })

  export default {
    metaInfo: {
      title: 'Wingz Support | Assign Rides', // set a title
    },
    name: 'AssignRides',
    data () {
      return {
        title: 'Assign Rides',
        isLoading: false,
        errors: null,
        booleanValue: false,
        totalRows: 0,
        perPage: 20,
        limit: 10,
        currentPage: 1,
        toastPosition: 'bottom-center',
        newlyAssignedRideId: [],
        selected_status: 16,
        id_group_ride: null,
        rider_email: null,
        driver_name_first: null,
        driver_name_last: null,
        rider_name_first: null,
        rider_name_last: null,
        default_pickup_address: null,
        default_dropoff_address: null,
        selected_market: "All",
        selected_ride_type: 'All',
        min_date: null,
        max_date: null,
        selected_booking_mode: 'All',
        min_reservation_date: null,
        max_reservation_date: null,
        selected_update_status: null,
        page_sizes: [20, 50, 100],
        markets: null,
        data: {
          checkboxes: false,
          resultColumns: ["Ride ID", "Leg ID", "Trip ID", "Market", "Ride Type", "Vehicle Type", "Booking Mode", "Rider", "Booked At", "Expires At", "Pick-Up Date", "From", "To", "Driver Revenue", "Status"],
          showErrorModal: false,
          showDriverSelectModal: false,
          showAutoAssignModal: false,
          showSendBackModal: false,
          showStatusUpdateModal: false,
          drivers: [],
          rides: [],
          pool: [],
          finishedPool: [],
          markets: null,
          isCheckAll: false,
          driverSelectMessage: "Select a driver",
          sortDirection: 0,
          filters: {
            status: {
              "unassigned":15,
              "general_distribution":16,
              "expired":18,
              "received_after_pickup": 25,
              "accepted": 7
              // "paid_denied": 24
            }
          },
          filteredRides: [],
          sortedRides: [],
        },
      }
    },
    components: {
      Loading
    },
    methods: {
      assign: function(event) {
        var choice = document.getElementById("driver-selection").value
        this.newlyAssignedRideId = []
        if(choice == this.data.driverSelectMessage) {
          Vue.toasted.show('Please select a driver', {
            theme: 'bubble',
            position: this.toastPosition,
            duration: 2000
          })
        }
        else {
          this.isLoading = true
          choice = choice.split(" - ")[0]
          for(var count in this.data.pool) {
            let params = {"designated_id_driver": choice}
            var id = this.data.pool[count].id_ride
            this.newlyAssignedRideId.push(id);

            this.$http
              .patch(process.env.API_BASE_URL_CS + 'rides/' + id + "/?type=assign", params)
              .then(response => {
                // this.$delete(this.data.pool, count)
              })
              .catch(error => {
            this.check403(error);
            if (error.response != null && error.response.status != null && error.response.status == 401) {
              console.warn("redirect to login")
              this.handle401()
            }
                console.log(error.response)
                this.errors = error.response.data
                this.non_field_errors = error.response.data.non_field_errors
                this.newlyAssignedRideId.pop()
              })
              .finally(() => {
                this.data.finishedPool = this.data.pool
                this.data.pool = []
                this.getAllDrivers()
              })
          }
          this.data.showDriverSelectModal = false;
        }
        // setTimeout(this.getMarkets, 250)
      },
      getMarkets: function () {
        this.isLoading = true
        this.$http
          .get(process.env.API_BASE_URL_CS + 'markets/')
          .then(response => {
            console.log('markets response', response.data)
            this.markets = response.data
          })
          .catch(error => {
            this.check403(error);
            if (error.response.status == 401) {
              console.warn("redirect to login")
              this.handle401()
            }
            Vue.toasted.show('Something went wrong!', {
              theme: 'bubble',
              position: 'top-right',
              duration: 2000
            })
            console.log(error.response)
            this.errors = error.response.data
            this.non_field_errors = error.response.data.non_field_errors
          })
      },
      auto_assign: function(event) {
        this.isLoading = true
        for(var count in this.data.pool) {
          var id = this.data.pool[count].id_ride
          this.newlyAssignedRideId.push(id);

          this.$http
            .patch(process.env.API_BASE_URL_CS + 'rides/' + id + "/?type=auto_assign", {})
            .then(response => {
              // this.$delete(this.data.pool, count)
            })
            .catch(error => {
              this.check403(error);
              if (error.response != null && error.response.status != null && error.response.status == 401) {
                console.warn("redirect to login")
                this.handle401()
              }
              console.log(error.response)
              this.errors = error.response.data
              this.non_field_errors = error.response.data.non_field_errors
              this.newlyAssignedRideId.pop()
            })
            .finally(() => {
              this.data.finishedPool = this.data.pool
              this.data.pool = []

              this.isLoading = false
            })
        }
        this.data.showAutoAssignModal = false;
        // setTimeout(this.getMarkets, 250)
      },
      distribute: function(event) {
        if(this.data.pool.length == 0) {
          this.data.showErrorModal = true
          return
        }
        this.newlyAssignedRideId = []
        let type = event.target.id == "paymentPendingTrue" ? "payment_pending" : event.target.id == "cancelTrue" || event.target.id == "cancelFalse" ? "cancel" : event.target.id == "general" ? "LINEAR" : event.target.id == "blast" ? "blast" : event.target.id == "assign" ? "ASSIGN" : "LOGARITHMIC"
        var sendBack = false
        if (event.target.id == "cancelTrue") {
          sendBack = true
        }
        if(type == "ASSIGN") {
          this.data.showDriverSelectModal = true
        }
        else{
          this.isLoading = true
          for (let i = 0; i < this.data.pool.length; i++) {
            this.newlyAssignedRideId.push(this.data.pool[i].id_ride);
            let cur = this.data.pool[i]
            let params = type == "cancel" ? { sendBack: sendBack } : type == "LINEAR" || type =="LOGARITHMIC" ? { distribution_method: type } : { distribution_method: "LINEAR" }
            this.$http
              .patch(process.env.API_BASE_URL_CS + 'rides/' + this.data.pool[i].id_ride + "/?type=" + (type == "cancel" ? "cancel" : type =="payment_pending" ? "payment_pending" : type =="blast" ? "blast" : "assign"), params)
              .then(response => {
              })
              .catch(error => {
            this.check403(error);
            if (error.response.status == 401) {
              console.warn("redirect to login")
              this.handle401()
            }
                Vue.toasted.show('Unable to distribute!', {
                  theme: 'bubble',
                  position: this.toastPosition,
                  duration: 2000
                })
                console.log(error.response)
                this.errors = error.response.data
                this.non_field_errors = error.response.data.non_field_errors
                this.newlyAssignedRideId.pop()
              })
              .finally(() => {
                this.data.pool = []
                this.getAllDrivers()
              })
          }
        }
      },
      assignSearch: function (page) {
        this.$http
          .get(process.env.API_BASE_URL_CS + 'rides/?type=unassigned'
            + (this.id_group_ride == null ? '' : '&id_group_ride=' + this.id_group_ride)
            + (this.selected_status == null ? '' : '&id_type_ride_status=' + this.selected_status)
            + (this.rider_email == null || this.rider_email.length==0 ? '' : '&contact_email__icontains=' + this.rider_email)
            + (this.driver_name_first == null || this.driver_name_first.length==0 ? '' : '&id_driver__name_first__icontains=' + this.driver_name_first)
            + (this.driver_name_last == null || this.driver_name_last.length==0 ? '' : '&id_driver__name_last__icontains=' + this.driver_name_last)
            + (this.rider_name_first == null || this.rider_name_first.length==0 ? '' : '&contact_first_name__icontains=' + this.rider_name_first)
            + (this.rider_name_last == null || this.rider_name_last.length==0 ? '' : '&contact_last_name__icontains=' + this.rider_name_last)
            + (this.default_pickup_address == null || this.default_pickup_address.length==0 ? '' : '&default_pickup_address__icontains=' + this.default_pickup_address)
            + (this.default_dropoff_address == null || this.default_dropoff_address.length==0 ? '' : '&default_dropoff_address__icontains=' + this.default_dropoff_address)
            + (this.selected_market == "All" ? '' : '&id_market=' + this.selected_market.id_market)
            + (this.min_date == null ? '' : '&date_pickup__gte=' + this.min_date)
            + (this.max_date == null ? '' : '&date_pickup__lte=' + this.max_date)
            + (this.selected_booking_mode == null || this.selected_booking_mode == "All" ? '' : '&booking_mode=' + this.selected_booking_mode)
            + (this.min_reservation_date == null ? '' : '&date_reservation__gte=' + this.min_reservation_date)
            + (this.max_reservation_date == null ? '' : '&date_reservation__lte=' + this.max_reservation_date)
            + (this.selected_ride_type == null || this.selected_ride_type == 'All' ? '' : '&deadhead=' + this.selected_ride_type)
            + '&ordering=' + (this.prev_sort ? (this.prev_sort.getAttribute('value')>0 ? '' : '-') + this.prev_sort.getAttribute('name') : '')
            + '&page=' + (page ? page : this.currentPage)
            + '&page_size=' + (this.perPage)
          )
          .then(response => {
            this.data.rides = response.data.results
            this.data.filteredRides = this.data.rides.slice(0)
            this.data.sortedRides = this.data.rides.slice(0)

            if (response.data && response.data.count) {
              this.totalRows = response.data.count
            }
          })
          .catch(error => {
            this.check403(error);
            if (error.response.status == 401) {
              console.warn("redirect to login")
              this.handle401()
            }
            console.log(error)
            this.errored = true
          })
          .finally(() => this.isLoading = false)
        this.isLoading = true
      },
      assignButtonSearch(page) {
        this.resetPager()
        this.assignSearch(page)
      },
      resetPager: function () {
        this.currentPage = 1
        this.totalRows = 0
      },
      selectedVehicleTypes: function() {
        var vehicle_type = null;
        for (var i in this.data.pool) {
            if (this.data.pool[i].tag_values && this.data.pool[i].tag_values.length > 0) {
              for (var j=0; j < this.data.pool[i].tag_values.length; j++) {
                if (this.data.pool[i].tag_values[j].code == "vehicle_type" && this.data.pool[i].tag_values[j].values) {
                  for (var k=0; k < this.data.pool[i].tag_values[j].values.length; k++) {
                    if (!vehicle_type) {
                      vehicle_type = this.data.pool[i].tag_values[j].values[k].value
                    } else if (!vehicle_type.includes(this.data.pool[i].tag_values[j].values[k].value)) {
                      vehicle_type = vehicle_type + ", " + this.data.pool[i].tag_values[j].values[k].value
                    }
                  }
                }
              } 
            }
        }        
        return vehicle_type;
      },
      getAllDrivers: function () {
        this.isLoading = true
        this.$http
          .get(process.env.API_BASE_URL_CS + 
              'drivers-search/?id_driver__id_type_driver_status=1' +            
              // (this.selectedVehicleTypes() ? "&vehicle_type=" + this.selectedVehicleTypes() : "") +
              "&tags=26"
          )
          .then(response => {
            this.data.drivers = response.data
          })
          .catch(error => {
            this.check403(error);
            if (error.response.status == 401) {
              console.warn("redirect to login")
              this.handle401()
            }
            Vue.toasted.show('Unable to retrieve drivers!', {
              theme: 'bubble',
              position: this.toastPosition,
              duration: 2000
            })
            console.log(error.response)
            this.errors = error.response.data
            this.non_field_errors = error.response.data.non_field_errors
          })
          .finally(() => {
            // this.getRides(this.page)
            this.assignSearch()
            // this.isLoading = false
          })
      },
      changePage: function (page) {
        this.assignSearch(page)
      },
      checkPageSize: function(event) {
        this.assignSearch()
      },
      checkSelection: function(event) {
        this.data.isCheckAll = event.srcElement.selectedIndex == 1 ? false : true
        this.checkAll()
      },
      checkAll: function() {
        this.data.isCheckAll = !this.data.isCheckAll
        this.data.pool = []
        if(this.data.isCheckAll){ // Check all
          for (var key in this.data.sortedRides) {
            this.data.pool.push(this.data.sortedRides[key])
          }
        }
      },
      clearDate(date) {
        if (date == 'min_date') {
          this.min_date = null
        }
        if (date == 'max_date') {
          this.max_date = null
        }
        if (date == 'min_reservation_date') {
          this.min_reservation_date = null
        }
        if (date == 'max_reservation_date') {
          this.max_reservation_date = null
        }
      },
      filterDriverByMarkets: function(driver) {
        var selectedMarkets = []
        var selectedTypes = []

        var vehicleTypes = this.selectedVehicleTypes()

        for (var i in this.data.pool) {
          var market = this.data.pool[i].id_market.id_market
          var deadhead = (this.data.pool[i].deadhead ? 'deadhead' : 'individual')
          if (market == driver.id_driver.id_market.id_market && deadhead == driver.id_driver.id_type_driver_account.code) {
            if (!vehicleTypes) {
              // if no selected vehicle types then include the driver without checking his tags
              return true;
            } else if (driver.tags && driver.tags.length > 0) {
              // driver with no tags will not be included if selected rideshave tags
              for (var j=0; j < driver.tags.length; j++) {
                if (driver.tags[j].tag.code == "vehicle_type" && driver.tags[j].value  && vehicleTypes.includes(driver.tags[j].value)) {
                  return true;
                }
              } 
            }

          }
        }
        return false;
      }
    },
    mounted(){
      this.getAllDrivers()
      this.getMarkets()
    },
    created () {
      // document.title = "Wingz Support | Assign Rides";
    }
  }
</script>

<style scoped>
  /* .sub-header{
    font-style: italic;
  } */
  /* .ride-item{
    height: 50px;
  } */
  th, td {
    vertical-align: middle;
  }
  .ride-filters{
    display: flex;
  }
  /* .ride-filter{
    margin-bottom: 20px !important;
    margin-left: 10px !important;
  } */
  .assign-ride-actions {
    display: block;
    text-align: right;
  }
  .assign-ride-actions .submit-button {
    display: inline-block;
  }

  .default-checkbox {
    position: relative;
    opacity: 1;
    left: 0;
  }
  select.table-select.form-control {
    border: none;
    outline: 0px;
    height: inherit;
  }
 .table td {
    vertical-align: middle;
  }
  .table th > div {
    position: relative;
    display: inline;
  }
  .table th > div .arrow-down {
    position: absolute;
    right: -13px;
    top: 40%;
  }
</style>




// WEBPACK FOOTER //
// src/components/AssignRides.vue